/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable global-require */
// import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { DeviceType } from 'Type/Device';

import appBanner from './images/App-banner-min.jpg';
import appBannerMobile from './images/App-banner-mob.jpg';
import Delivery from './images/Labs-at-your-home.svg';
import Trusted from './images/Trusted-by-customers.svg';
import Arthentic from './images/Verified-Products.svg';

import './StaticBlocks.style';

/** @namespace Mspwa/Component/StaticBlocks/Component/mapStateToProps */
/** @namespace Mspwa/Component/Menu/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    device: state.ConfigReducer.device
});

/** @namespace Mspwa/Component/StaticBlocks/Component/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Mspwa/Component/StaticBlocks/Component/StaticBlocksComponent */
export class StaticBlocksComponent extends PureComponent {
    static propTypes = {
        device: DeviceType.isRequired
    };

    openAndroid() {
        window.open(
            'https://play.google.com/store/apps/details?id=com.biopharma.medisouq',
            '_blank'
        );
    }

    openIOS() {
        window.open(
            'https://apps.apple.com/us/app/medisouq/id1480496610',
            '_blank'
        );
    }

    render() {
        const {
            device: { android, ios, safari }
        } = this.props;

        return (
            <div block="BasicServices" className="BasicServices">
                <div className="Home">
                    <img
                      className="Home-Image"
                      src={ appBanner }
                      onClick={ () => {
                          if (android) {
                              return this.openAndroid();
                          }
                          if (ios || safari) {
                              return this.openIOS();
                          }

                          this.openAndroid();
                      } }
                      alt="medisouq-mobile-app"
                    />
                    <img
                      className="Home-Image-Mobile"
                      src={ appBannerMobile }
                      alt="medisouq-mobile-app"
                      onClick={ () => {
                          if (android) {
                              return this.openAndroid();
                          }
                          if (ios || safari) {
                              return this.openIOS();
                          }

                          this.openAndroid();
                      } }
                    />
                </div>
                <div>
                    <div className="BasicServices-ImgBottom">
                        <div className="BasicServices-ImgBottom-ImgContainer">
                            <img src={ Arthentic } alt="" />
                        </div>

                        <div className="BasicServices-ImgBottom-ImgContainer">
                            <img src={ Delivery } alt="" />
                        </div>
                        <div className="BasicServices-ImgBottom-ImgContainer">
                            <img src={ Trusted } alt="" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StaticBlocksComponent);
